<template>
  <div>
    <el-table v-loading="loading" ref="Ytable" :data="tableDataList" border size="mini" v-bind="$attrs"
              :style="[{ width: '100%' }, { fontSize: fonts ? fonts : '12px' }]" v-on="$listeners"
              :default-expand-all="expendAll" lazy :row-key="rowKey"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :max-height="maxHeight" :height="height"
              highlight-current-row @selection-change="selectionChage" @select="handleSelectChange"
              @current-change="currentChange" @row-dblclick="(row, column, event) => rowDbClick(row, column, event)"
              @row-click="(row, column, event) => rowClick(row, column, event)" @sort-change="sortChange"
              @cell-click="cellClick" @keydown.tab.native="handleTab(noShowName)" @header-dragend="changeheight"
              @select-all="selectAllData" :show-summary="showSummary" :summary-method="getSummaries"
              :header-cell-class-name="cellClass"  :cell-style="headFirst">
      <el-table-column :selectable="checkSelect" type="selection" width="60" align="center" fixed="left" :reserve-selection="true"/>
      <!-- v-if="selection" -->
      <!-- label="序号" -->
      <el-table-column v-if="index" :label="$t('configMoudle.linenum')" type="index" width="60" align="center" fixed="left"
                       header-align="center" sortable></el-table-column>
      <!-- v-if="index" -->
      <!-- v-show="val.showName !== '' && val.showName !== null && val.showName !== undefined" -->
      <!-- val[alingitem] == 1 ? 'left' : (val[alingitem] == 2 ? 'center' : 'right') -->
      <el-table-column v-for="(val, index) in columnList" :key="index" :prop="val[columnKey]" :label="val[columnLabel]"
                       :resizable="val.resizable || true" :fixed="val.fixed || val.isLocked"
                       :align="val[alingitem] == 1 ? 'left' : val[alingitem] == 2 ? 'center' : val[alingitem] == 3 ? 'right' : 'left'"
                       header-align="center" :min-width="val.width === 'auto' ? '' : val.width || val.colWidth || 120"
                       :sortable="'custom'" sortable :show-overflow-tooltip="val.fieldName != 'img_ids'">
        <!-- 表头批量修改图标 -->
        <template #header="{ column }">
          {{ column.label }}
          <br v-if="headerbe" />
          <el-popover placement="top" width="400" trigger="click">
            <el-input v-model="val.inputSearch" size="mini" clearable :placeholder="$t('configMoudle.content')"
                      @keyup.enter.native="handleSearch(column)"></el-input>
            <i v-if="isColumnFilter" style="cursor: pointer" class="el-icon-search" slot="reference"
               @click.stop="handleHeaderSearch(column, index, val)"></i>
          </el-popover>
          <!-- 配置页表头批量编辑 -->
          <i v-if="!val.isReadOnly && isBatchModify && isEditOutline" style="cursor: pointer" class="vxe-icon--edit-outline"
             @click.stop="handleHeaderEdit(column)"></i>
          <!-- 非配置页表头批量编辑 -->
          <i v-else-if="(editCell && !val.isReadOnly) && isSchemeEdit && !(isBatchModify && isEditOutline)"
             style="cursor: pointer" class="vxe-icon--edit-outline" @click.stop="handleHeaderBatchEdit(val, column)"></i>
        </template>
        <template #default="scope">
          <span v-if="val.jumpMenu">
            <span class="jump-menu" v-for="jumpNo in splitStr(scope.row[val[columnKey]])" @click="jumpMenu(val, scope.row, jumpNo)">{{ jumpNo }}</span>
          </span>
          <!-- 行内编辑显示 -->
          <slot v-else-if="isEdited && (((editCell && !val.isReadOnly) ||
            (val.isEditableUnderApproval && $route.query.peddingApproval && !tabItemIsReadOnly)) &&
            val[columnKey] === cellColumn && scope.row.$index === cellRow) ||
            (val[columnKey] === cellColumn && scope.row.$index === cellRow && $route.path == '/CW/sdrl_edit')"
                name="myColumn" :row="scope.row" :column="val" :$index="scope.$index">
          </slot>
          <div v-else-if="val.fieldName === 'placed'">
            <span v-if="scope.row.placed === '-1'">{{ $t('Approval.reject') }}</span>
            <span v-else-if="scope.row.placed === '0'">{{ $t('feedback.notStarted') }}</span>
            <span v-else-if="scope.row.placed === '2'">{{ $t('addTips.pass') }}</span>
            <span v-else>{{ $t('addTips.approve') }}</span>
          </div>
          <div v-else-if="val.fieldName === 'http'" style="text-decoration: underline; color: #551a8b">
            <a :href="scope.row[val[columnKey]]" target="_Blank" @click="handlePreview(scope.row, val)">
              {{ scope.row[val[columnKey]] | booleanFilter(val, itemsConfigVOs) }}</a>
          </div>

          <!-- 图片 -->
          <div v-else-if="val.fieldName === 'real_attach_name'" style="text-decoration: underline; color: #551a8b">
            <span @click="handleFileView(scope.row, val)" style="cursor: pointer">
              {{ scope.row[val[columnKey]]}}</span>
          </div>
          <el-image v-else-if="val.fieldName === 'img_ids' && Array.isArray(scope.row.img_ids) && scope.row.img_ids[0] && scope.row.img_ids[0].url"
                    style="height: 100px; width: 100px; margin-right: 10px;" fit="scale-down"
                    :src="scope.row.img_ids[0].url" alt="" :preview-src-list="[scope.row.img_ids[0].originUrl]">
          </el-image>
          <div v-else-if="val.fieldName === 'img_ids'"
               style="height: 100px; width: 100px; margin-right: 10px"></div>
          <!-- 表格显示 -->
          <template v-else>
            <span v-if="
              ($route.path == '/CW/fksq_view' ||
                $route.path == '/CW/sfgl_view' ||
                $route.path == '/CW/sfgl_add' ||
                $route.path == '/CW/fksq_add' ||
                $route.path == '/CW/fksq_edit' ||
                $route.path == '/CW/sfgl_edit') &&
              val.fieldName === 'pono'
            " :style="$route.path == '/CW/fksq_view' ||
                  $route.path == '/CW/sfgl_view' ||
                  $route.path == '/CW/sfgl_add' ||
                  $route.path == '/CW/fksq_add' ||
                  $route.path == '/CW/fksq_edit' ||
                  $route.path == '/CW/sfgl_edit'
                  ? 'width: 100%;color:blue;text-decoration:underline'
                  : 'width: 100%;'
                ">
              {{ scope.row[val[columnKey]] | booleanFilter(val, itemsConfigVOs) }}
            </span>
            <span v-else v-show="scope.row[val[columnKey]] || scope.row[val[columnKey]] === 0"
                  :style="scope.row.subtotal ? 'color:red;font-weight:bold;background-color:rgb(192,195,202);width:100%;' : 'width: 100%;'">
              {{ scope.row[val[columnKey]] | booleanFilter(val, itemsConfigVOs) }}
            </span>
          </template>
        </template>
      </el-table-column>
      <template v-if="(this.$route.path !== '/kcgl/kccx' && !handleDisable) || cwqrisok">
        <slot name="handle">
          <Y-table-Handle @handleClickHandle="handleClickHandle" @handleExport="handleExport"
                          @handleImport="handleImport" @handleSettings="handleSettings" :isExcelExport="isExcelExport"
                          :isExcelImport="isExcelImport" :columnSetting="columnSetting" :headerbr="headerbe" />
        </slot>
      </template>
      <template v-if="handleDisable && (handleBtn.length || $route.query.biaoshi) && !cwqrisok">
        <slot name="handle">
          <Y-table-Handle :handleDisable="handleDisable" @handleClickHandle="handleClickHandle"
                          @handleExport="handleExport" @handleImport="handleImport" @handleSettings="handleSettings"
                          :isExcelExport="isExcelExport" :isExcelImport="isExcelImport" :columnSetting="columnSetting"
                          :headerbr="headerbe" />
        </slot>
      </template>
    </el-table>
    <el-dialog :visible.sync="imgdivDialogVisible" style="width: 100%">
      <div style="margin: 0 auto; text-align: center">
        <img :src="imgUrl" style="width: 500px; height: auto" alt="" />
      </div>
    </el-dialog>
    <footer v-if="total" style="text-align: end; user-select: none">
      {{ _total }}
    </footer>
  </div>
</template>

<script>
import { judgeCellData } from "@/assets/js/table";
import { isFunction } from "@/utils/validate";
import { findPoctrl } from "@/api/detail";
import Sortable from "sortablejs";
import { getCellColor } from "@/api/sysTem/index";
import { mapState } from "vuex";
import { getSession, checkFont, deepFindOne } from "@/utils/methods";
import clone from "clone";
import {renderData} from "@/api/list";

export default {
  name: "Y-table",
  props: {
    cellClassdiabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headerbe: {
      type: Boolean,
      default: false,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    column: {
      type: Array,
      default: () => [],
    },
    itemsConfigVOs: {
      type: Array,
      default: () => [],
    },
    isColumnFilter: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    selection: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Boolean,
      default: true,
    },
    total: {
      type: [Boolean, String],
      default: false,
    },
    totalData: {
      type: Object,
      default: () => { },
    },
    selectionKey: String,
    expendAll: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      type: String,
      default: "id",
    },
    alingitem: {
      type: String,
      default: "",
    },
    columnKey: {
      type: String,
      default: "prop",
    },
    columnLabel: {
      type: String,
      default: "label",
    },
    handleBtn: {
      type: Array,
      default: () => [],
    },
    handleWidth: {
      type: [String, Number],
      default: "170",
    },
    handleDisable: {
      type: Boolean,
      default: false,
    },
    cwqrisok: {
      type: Boolean,
      default: false,
    },
    editCell: Boolean,
    isImage: {
      type: Boolean,
      default: false,
    },
    isExcelExport: {
      type: Boolean,
      default: false,
    },
    isExcelImport: {
      type: Boolean,
      default: false,
    },
    columnSetting: {
      type: Boolean,
      default: false,
    },
    isBatchModify: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
    },
    maxHeight: {
      type: [String, Number],
    },
    tabItemIsReadOnly: {
      type: Boolean,
      default: false,
    },
    editedByOthers: {
      type: Boolean,
      default: false,
    },
    isFit: {
      type: Boolean,
      default: false,
    },
    commonHeight: {
      type: Number,
      default: 10,
    }
  },
  data() {
    return {
      fonts: null,
      cellColumn: null,
      cellRow: null,
      columnListcount: 0,
      noShowName: [],
      tableDataList: [],
      imgUrl: "",
      imgdivDialogVisible: false,
      isEdited: true,
      isEditOutline: false,
      isSchemeEdit: false,
      colorList: []
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.global.userInfo,
    }),
      routes() {
      return this.$store.state.global.routes;
    },
    columnList() {
      // 不知为啥created里面获取不到noShowName
      this.noShowName = this.column.filter((row) => {
        return (
          row.showName !== "" &&
          row.showName !== null &&
          row.showName !== undefined &&
          row.isShow
        );
      });
      return this.column.filter((item) => {
        return (
          (item.hasOwnProperty("isShow") &&
            item.isShow &&
            item.showName !== "" &&
            item.showName !== null &&
            item.showName !== undefined) ||
          !item.hasOwnProperty("isShow")
        );
      });
    },
    routes() {
      return this.$store.state.global.routes;
    },
    path() {
      return this.$route.path;
    },
  },
  created() {
    this.fitHeight()
    this.column.map(async (item) => {
      if (isFunction(item.list)) {
        item.list = await item.list();

      }
    });
    this.column.forEach((item) => this.$set(item, "inputSearch", ""));
    this.noShowName = this.column.filter((row) => {
      return (
        row.showName !== "" &&
        row.showName !== null &&
        row.showName !== undefined
      );
    });
    this.tableDataList = this.tableData.map((item) => {
      for (let i in item) {
        if (item[i] === "true") {
          item[i] = true;
        } else if (item[i] === "false") {
          item[i] = false;
        }
      }
      return item;
    });
  },
  activated() { },
  deactivated() {
    this.$nextTick(() => {
      let list = document.getElementsByClassName("el-tooltip__popper");
      if(list.length > 0) {
        list.forEach((item) => {
          item.style.display = "none";
        });
      }
    });
  },
  watch: {
    tableData(newVal, oldVal) {
      if (oldVal?.length) return;
      this.$refs.Ytable.setCurrentRow(newVal[0]);
    },
    tableData: {
      handler(newVal) {
        this.tableDataList = newVal.map((item) => {
          for (let i in item) {
            if (item[i] === "true") {
              item[i] = true;
            } else if (item[i] === "false") {
              item[i] = false;
            }
          }
          return item;
        });
      }, deep: true, immediate: true,
    },
    handleBtn: {
      handler(newVal) {
        newVal.forEach(item => {
          this.isEdited = newVal.some(item => item.key === 'edit' || item.key === 'delete');
          if(!this.editedByOthers) {
            this.isEdited = false
          } else this.isEdited = true
        })
      }, deep: true, immediate: true
    },
    handleBtn: {
      handler(newVal) {
        this.isEditOutline = newVal?.some(item => item.key == "edit") || false;
      }, deep: true, immediate: true
    },
    // 这里判断非配置页是否需要表头批量编辑
    '$route': {
      handler(route) {
        if (route.name != 'editProgramme' && route.name != 'earlyWarningSetting') {
          this.isSchemeEdit = true
        } else this.isSchemeEdit = false
      }, deep: true, immediate: true,
    }
  },
  mounted() {
    document.body.ondrop = function (e) {
      e.stopPropagation();
    };
    // this.rowDrop();
    window.addEventListener("resize", this.handleResize);
    // 浏览器tab切换与表格tab切换方法冲突故阻止默认的tab切换
    window.addEventListener("keydown", (e) => {
      if (e.keyCode == 9) e.preventDefault();
    });
    this.fonts = checkFont();

    this.$nextTick(function () {
      // console.log('this.routes', this.routes)
      // console.log('this.path', this.path)
      try {
        const { formConfigId } = deepFindOne(this.routes, "formConfigId", this.path);
        if (formConfigId) {
          getCellColor({ formConfigId }).then((res) => {
            this.colorConfig = res.filter(item => item.activate).map(item => {
              return {
                ...item,
                conditions: JSON.parse(item.conditions)
              }
            })
          })
        }
      } catch (e) {}
    })
  },
  updated() {
    this.fitHeight()
  },
  methods: {
    getSelectedRows() {
      return this.$refs.Ytable.selection;
    },
    fitHeight() {
      try {
        if (!this.isFit) {
          return
        }
        const searchHeight = (document.getElementById('list-header-card')?.offsetHeight || 0)
        const mainHeight = (document.getElementById("frame-content")?.offsetHeight || 0)
        const sublist = (document.getElementById("list-sublist-card")?.offsetHeight || 0)
        const commonHeight = this.commonHeight
        if (sublist) {
          this.height = (mainHeight / 3 * 2) - searchHeight - commonHeight
        } else {
          this.height = mainHeight - searchHeight - commonHeight
        }
        // console.error('searchHeight', searchHeight)
        // console.error('mainHeight', mainHeight)
        // console.error('sublist', sublist)
      } catch (e) {}
    },
    // 图片悬浮显示
    handleImgClick(url) {
      this.imgdivDialogVisible = true;
      this.imgUrl = url;
    },

    // 表头增加样式
    cellClass(row) {
      if (row.columnIndex === 0 && this.cellClassdiabled) {
        return "disableheadselection";
      }
    },
    //设置分组小计行的样式
    rowClassName({row, rowIndwx}) {
      let className = "";
      if (row.subtotal) {
        className = "subtotalClass";
      }
      return className;
    },
    // 精准计算加法
    FloatAdd(arg1, arg2) {
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    numberAdd(arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m + arg2 * m) / m).toFixed(n);
    },
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("configMoudle.totalAll");
          return;
        }
        // subtotal == false过滤掉分组小计行，不参与计算
        const values = data.map((item) =>
          !item.subtotal ? Number(item[column.property]) : 0
        );
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return this.numberAdd(Number(prev), Number(curr));
            } else return Number(prev);
          }, 0);
          if (sums[index] !== "") {
            sums[index] = Number(sums[index]).toLocaleString();
          }
          for (let i = 0; i < this.columnList.length; i++) {
            if (this.columnList[i].showName == column.label) {
              if (this.columnList[i].isSum) {
                if (sums[index] === "" || sums[index] === null || sums[index] === undefined) {
                  sums[index] = 0;
                }
              } else sums[index] = "";
            }
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    handleResize() {
      this.$nextTick(() => {
        this.$refs.Ytable.doLayout();
      });
    },
    changeheight() {
      this.$refs.Ytable.doLayout();
    },
    selectAllData(selection) {
      this.$emit("selectAllData", selection);
    },
    cellClick(row, column, cell, event) {
      this.cellRow = row.$index;
      this.cellColumn = column.property;
      const isSystemPath = this.containsSystemPath(this.$route.path);
      const isCurrentUser = row.create_by === this.user.user.username;
      if (!isSystemPath) {
        this.isEdited = isCurrentUser ? true : this.editedByOthers;
      }
      this.$emit("cellClick", row, column, cell, event);

      // if (column.className === 'jump-menu') {
      //   const field = this.column.find(item => item.fieldName === column.property)
      //   this.jumpMenu(field, row, column)
      // }
    },
    cellMouseEnter(row, column, cell, event) {
      this.$nextTick(_ => {
        let list = document.getElementsByClassName('el-tooltip__popper')
        if (list.length) {
          list[list.length - 1].style.display = 'none'
        }
      })
    },
    containsSystemPath(path) {
      // 定义正则表达式，使用 /system 字符串进行匹配
      const regex = /\/(system|flow)/;
      // 使用 test 方法检查路径是否包含 /system
      return regex.test(path);
    },
    columncountfunction(column, datacolumn) {
      let newcolumns = null;
      if (datacolumn?.fieldName !== column[column.length - 1]?.fieldName) {
        if (column[Number(datacolumn.index) + 1].isReadOnly) {
          return this.columncountfunction(
            column,
            column[Number(datacolumn.index) + 1]
          );
        } else {
          let a = null;
          a = clone(column[Number(datacolumn.index) + 1]);
          newcolumns = a;
          return newcolumns;
        }
      } else {
        // 最后一个column才会走
        for (let i = 0; i < column.length; i++) {
          if (!column[i].isReadOnly) {
            newcolumns = column[i];
            return newcolumns;
          }
        }
      }
    },
    handleTab(column) {
      let finalRow = false;
      let index = column.find((item, index) => {
        if (item?.fieldName == this.cellColumn) {
          item.index = index;
          if (index == column.length - 1) finalRow = true;
          return item;
        }
      });
      if (finalRow) this.cellRow = Number(this.cellRow) + Number(1);
      for (let i = 0; i < column.length; i++) {
        column[i].index = i;
      }
      let newcolumn = clone(column);
      let newcolumncountfunction = this.columncountfunction(
        newcolumn,
        column[Number(index.index)]
      );
      this.cellColumn = newcolumncountfunction.fieldName;
      this.$refs.Ytable.bodyWrapper.scrollLeft = Number(
        this.$refs.Ytable.bodyWidth.replace("px", "")
      );
    },
    setCurrentRow(row) {
      this.$refs.Ytable.setCurrentRow(row);
    },
    sortChange({column, prop, order}) {
      this.$emit("sortChange", {column, prop, order}, this.tableData);
    },
    currentChange(row, oldRow) {
      this.$emit("currentChange", row, oldRow);
    },
    selectionChage(selection) {
      this.$emit("selectionChage", selection);
    },
    handleSelectChange(selection, row) {
      this.$emit("handleSelectChange", selection, row);
    },
    b64EncodeUnicode(str) {
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
    },
    handleFileView(row) {
      let onlinePreviewUrl = window.onlinePreviewUrl;
      if (row.accessUrl) {
        let startIndex = row.accessUrl.lastIndexOf(".")
        let str = row.accessUrl.substring(startIndex + 1, row.accessUrl.length)
        if (str == 'jpeg' || str == 'pdf' || str == 'png' || str == 'jpg' || str == 'jpe' || str == 'pns') {
          let link = document.createElement("a");
          link.href = row.accessUrl;
          link.target = "_blank";
          link.click();
        } else {
          if (onlinePreviewUrl) {
            var modifiedUrl = row.accessUrl.replace(/\\/g, "/");
            var b64Encoded = this.b64EncodeUnicode(modifiedUrl);
            let link = document.createElement("a");
            link.href = onlinePreviewUrl + '?url=' + encodeURIComponent(b64Encoded);
            link.target = "_blank";
            link.click();
          } else {
            this.$message('文件预览服务未部署!')
          }
        }
      }
    },
    handleClickHandle({e, scope}) {
      let title = e.target.getAttribute("val");
      if (!title) return;
      if (title === "delete") {
        this.$confirm(
          this.$t("userAdmin.tip3"),
          this.$t("configMoudle.tip"),
          {
            confirmButtonText: this.$t("configMoudle.confirm"),
            cancelButtonText: this.$t("configMoudle.cancel"),
            type: "warning",
          }
        ).then((res) => {
          this.$emit("handleClickHandle", {title, scope});
        })
        // if (getSession("LanguageName") == "zh-cn") {
        //   this.$confirm(
        //     this.$t("userAdmin.tip3"),
        //     this.$t("configMoudle.tip"),
        //     {
        //       confirmButtonText: this.$t("configMoudle.confirm"),
        //       cancelButtonText: this.$t("configMoudle.cancel"),
        //       type: "warning",
        //     }
        //   ).then((res) => {
        //     this.$emit("handleClickHandle", { title, scope });
        //   })
        // } else if (getSession("LanguageName") == "en") {
        //   this.$confirm("Confirm deletion?", "hint", {
        //     confirmButtonText: "confirm",
        //     cancelButtonText: "cancel",
        //     type: "warning",
        //   }).then((res) => {
        //     this.$emit("handleClickHandle", { title, scope });
        //   })
        // }
      } else {
        this.$emit("handleClickHandle", {title, scope});
      }
    },
    handleExport({e, scope}) {
      let title = scope.column.className;
      if (title == "y-handle") this.$emit("handleExport", {title});
    },
    handleImport({e, scope}) {
      let title = scope.column.className;
      if (title == "y-handle") this.$emit("handleImport", {title});
    },
    handleSettings({e, scope}) {
      let title = scope.column.className;
      if (title == "y-handle") this.$emit("handleSettings", {title});
    },
    handleHeaderEdit(column) {
      this.$emit("handleHeaderEdit", column);
    },
    handleHeaderBatchEdit(row, column) {
      this.$emit("handleHeaderBatchEdit", row, column);
    },
    handleHeaderSearch(column, idx, val) {
      // this.$emit("handleHeaderSearch", column)
      // console.log(column, idx, val);
    },
    handleSearch(column) {
      this.$emit("handleHeaderSearch", this.columnList);
    },
    rowDbClick(row, column) {
      if (
        (this.$route.path == "/CW/fksq_view" ||
          this.$route.path == "/CW/sfgl_view" ||
          this.$route.path == "/CW/sfgl_add" ||
          this.$route.path == "/CW/fksq_add" ||
          this.$route.path == "/CW/fksq_edit" ||
          this.$route.path == "/CW/sfgl_edit") &&
        column.property == "pono"
      ) {
        findPoctrl(row.pono).then((res) => {
          if (
            res.id == null ||
            res.id == "" ||
            res.id == "undefined" ||
            !res.id
          ) {
            this.$message({
              message: this.$t("addTips.orderNo"),
              type: "warning",
            });
            return;
          }
          this.$router.push({
            path: "/cggl/cght_view",
            query: {
              configId: res.configId,
              id: res.id,
              fno: res.fno,
              biaoshi: "true",
            },
          });
        });
      }
      this.$emit("rowDbClick", row, column);
    },
    rowClick(row, column) {
      this.$emit("rowClick", row, column);
    },
    checkSelect(row, index) {
      let ischecked = true
      if (row.ctname == '分组小计') {
        ischecked = false
      } else ischecked = true
      return ischecked
    },
    showInput(row) {
      return Object.values(row).some((item) => item);
    },
    headFirst({row, column, rowIndex, columnIndex}) {
      let config = this.colorConfig
      if (!config || !config.length) {
        return {}
      }
      // 将日期格式得筛选出来
      let dateTypeList = this.column.filter(item => item.dataType == 'date').map(item => item.fieldName)
      // // console.log('this.isKeySet',this.isKeySet)
      // // console.log('this.column',this.column)
      const rowData = this.tableDataList[rowIndex];
      let showNameList = this.column.filter(item => item.isShow).map(item => item.fieldName)
      if (this.isKeySet) {
        let obj = this.colorConfig.map(item => {
          return { fieldName: item.fieldName, rgb: item.rgb }
        })
        let nameList = this.colorConfig.map(item => item.fieldName)
        let showList = this.columnList.map(item => item.prop)
        if (nameList.includes(rowData.fieldName) && column.property == 'fieldName') {
          return 'background-color: ' + obj[nameList.findIndex(item => item === rowData.fieldName)].rgb + '!important'

        }
      }else {
        for (let i = 0; i < config.length; i++) {
          let stateList = new Array(config[i].conditions.length)
          for (let j = 0; j < config[i].conditions.length; j++) {
            let value1,value2
            // 第一种情况---单元格和值比较
            if (config[i].conditions[j].itemType1 == 2) {
              value1 = rowData[config[i].fieldName]
              value2 = config[i].conditions[j].fieldValue1
            }
            // 第二个情况---字段和值比较
            if (config[i].conditions[j].itemType2 == 2 && config[i].conditions[j].itemType1 == 1) {
              value1 = rowData[config[i].conditions[j].fieldValue1]
              value2 = config[i].conditions[j].fieldValue2
            }
            // 第三种情况---字段和字段比较
            if (config[i].conditions[j].itemType2 == 1 && config[i].conditions[j].itemType1 == 1) {
              value1 = rowData[config[i].conditions[j].fieldValue1]
              value2 = rowData[config[i].conditions[j].fieldValue2]
            }
            if (dateTypeList.includes(config[i].conditions[j].fieldValue1)) {
              stateList[j] = judgeCellData(switchTime(value1, "{y}-{m}-{d}"), config[i].conditions[j].judgeType,value2)
            }else {
              stateList[j] = judgeCellData(value1, config[i].conditions[j].judgeType, value2)
            }
            // conditionType 的值为1时，允许statusList中对应项的数据为false，当conditionType 的值为2时，不允许statusList中对应项的数据为false
            if (config[i].type == 2) { // 单元格
              if (this.evaluateDynamic(config[i].conditions, stateList) && (config[i].fieldName == column.property)) {
                return `background-color:${config[i].rgb}`
              }
            }else {
              if (this.evaluateDynamic(config[i].conditions, stateList)) {
                return `background-color:${config[i].rgb}`
              }
            }
          }

        }
      }
    },
    evaluateDynamic(conditionArray, resultArray) {
      let finalResult = true; // 初始结果设为true

      // 遍历所有条件和结果对
      for (let i = 0; i < conditionArray.length; i++) {
        const { conditionType } = conditionArray[i];
        const currentResult = resultArray[i];

        // 根据条件类型更新最终结果
        if (conditionType === 1) {
          // OR 逻辑：当前结果为true则最终结果变为true
          finalResult = finalResult || currentResult;
        } else {
          // AND 逻辑：当前结果为false则最终结果变为false
          finalResult = finalResult && currentResult;
        }

        // 短路优化：如果已经确定结果为false且下一个是AND，可以提前退出
        if (!finalResult && conditionArray[i+1]?.conditionType === 2) {
          break;
        }
      }

      return finalResult;
    },
    splitStr(value) {
      if (!value) {
        return value
      }
      return value.split(",");
    },
    jumpMenu(field, row, value) {
      console.log('field',field, row, value)
      if (!field.jumpMenu) {
        return
      }
      const router = deepFindOne(this.routes, "formConfigId", field.jumpMenu);
      if (!router) {
        this.$message.warning("没有菜单查看权限，请联系管理员");
        return;
      }
      const params = { configId: router.formConfigId, pageNum: 1, pageSize: 1 }
      const data = { filter: { fno: value || row[field.fieldName] } }
      renderData({ data, params })
        .then(res => {
          if (!res.result?.length) {
            this.$message.warning(this.$t("configMoudle.noFno"));
            return;
          }
          this.$router.push({
            name: `${router.path}_detailView`,
            query: {
              fno: value || row[field.fieldName],
              biaoshi: true,
              configId: router.formConfigId,
              id: res.result[0].id,
            },
          });
        })
    }
  },
  components: {},
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
/deep/ .disableheadselection > .cell .el-checkbox__inner {
  display: none;
}

/deep/ .el-table-column--selection {
  .cell {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    height: 100%;
  }
}

/deep/ .el-tooltip {
  display: flex;
  align-items: center;

  span {
    // width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

/deep/ .cell {
  div {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    font-weight: 400;
    // width: 100% !important;
  }
}

/deep/ .el-table th,
.el-table th.is-leaf {
  background: rgb(218, 219, 221) !important;
}

// /deep/ .el-table--border {
//   border-bottom: none!important;
// }
/deep/ .el-table--scrollable-x .el-table__body-wrapper {
  z-index: 2;
}

// /deep/ .el-table {
//   .el-table__fixed {
//     height: auto !important; // 此处的important表示优先于element.style
//     bottom: 45px !important; // 改为自动高度后，设置与父容器的底部距离，则高度会动态改变
//   }
// }
/deep/ .el-table--fluid-height .el-table__fixed,
.el-table--fluid-height .el-table__fixed-right {
  background: white;
}

/deep/ .el-table--mini .el-table__cell {
  // background: #ffffff;
  padding: 0 6px;
  font-size: inherit !important;
  // font-weight: 400;
}

/deep/ .cell.el-tooltip span {
  font-size: inherit !important;
}

/deep/ .el-table th.el-table__cell > .cell,
/deep/ .el-table td.el-table__cell > .cell {
  font-size: inherit !important;
}

/deep/ .subtotalClass {
  font-size: 14px;
  font-weight: bold;
}

/deep/ ::-webkit-scrollbar {
  width: 5px !important;
  /*滚动条宽度*/
  height: 10px !important;
  /* 滚动条高度 */
}

/deep/ .jump-menu {
  color: var(--primary);
  cursor: pointer;
  margin-right: 10px;
  text-decoration: underline;
}
</style>
